var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-datatable',{attrs:{"modelName":_vm.model,"actions":_vm.actions,"externalFilter":_vm.externalFilter,"masterDetail":_vm.masterDetail,"parentModelName":_vm.parentModelName,"isEditableRegistry":_vm.isEditableRegistry,"modelColumnDefs":_vm.modelColumnDefs,"modalDialog":_vm.modalDialog,"navigableDetail":false,"readOnly":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }